import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { CardComponent } from '@custom-components/general/card';
import { ListRowComponent } from '@custom-components/general/list-row/list-row.component';
import { StatusChipComponent } from '@custom-components/general/status-chip/status-chip.component';
import { PageHeaderBadge } from '@custom-components/layout/page-header/page-header.component';
import { RecentlyVisitedEntry } from '@core/services/recently-visited.service';

export type RecentlyVisitedRow = RecentlyVisitedEntry & {
  timeAgo: string;
  /** Only populated for `type === 'device'` entries — live status/meter-role chips resolved by
   * the dashboard page, since a recently-visited entry is a point-in-time snapshot that must
   * not cache mutable state like online/offline. */
  badges?: PageHeaderBadge[];
};

@Component({
  selector: 'xemex-dashboard-recently-used-widget',
  imports: [CardComponent, ListRowComponent, StatusChipComponent, MatIconModule, TranslateModule],
  styleUrl: './dashboard-recently-used-widget.component.scss',
  templateUrl: './dashboard-recently-used-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardRecentlyUsedWidgetComponent {
  entries = input.required<RecentlyVisitedRow[]>();

  entryClick = output<string[]>();
}
